import * as angular from 'angular';

import { DataTransactionDto, ModifiedObjectDto, TransactionType } from '../../models';
import { IRequestService } from '../request.service';

export interface IHistoryService {
    getModifiedObject(beginDateTime: string, endDateTime: string): angular.IPromise<ModifiedObjectDto[]>;
    getTransactions(beginDateTime: string, endDateTime: string): angular.IPromise<DataTransactionDto[]>;
    getLastTransaction(type: TransactionType): angular.IPromise<DataTransactionDto>;
}

// no-cache on purpose, all theses data could be changed by transaction in back
export class HistoryService implements IHistoryService {
    static serviceId = 'historyService';
    static ctrlUrl = 'history/';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getModifiedObject(beginDateTime: string, endDateTime: string): angular.IPromise<ModifiedObjectDto[]> {
        const actionUrl = `${HistoryService.ctrlUrl}GetModifiedObjects`;
        const params = {
            beginDateTime: beginDateTime,
            endDateTime: endDateTime
        };
        this._requestService.cleanCacheAtV1(actionUrl);
        this._requestService.cleanCacheAtV1(actionUrl, params);
        return this._requestService.getAtV1(actionUrl, params);
    }

    getTransactions(beginDateTime: string, endDateTime: string): angular.IPromise<DataTransactionDto[]> {
        const actionUrl = `${HistoryService.ctrlUrl}GetTransactions`;
        const params = {
            beginDateTime: beginDateTime,
            endDateTime: endDateTime
        };
        this._requestService.cleanCacheAtV1(actionUrl);
        return this._requestService.getAtV1(actionUrl, params);
    }

    getLastTransaction(type: TransactionType): angular.IPromise<DataTransactionDto> {
        const actionUrl = `${HistoryService.ctrlUrl}GetLastTransaction`;
        const params = {
            type: type
        };
        this._requestService.cleanCacheAtV1(actionUrl);
        return this._requestService.getAtV1(actionUrl, params);
    }
}